// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_chat_title = /** @type {(inputs: {}) => string} */ () => {
	return `Chat with Mochi`
};

const id_chat_title = /** @type {(inputs: {}) => string} */ () => {
	return `Ngobrol dengan Mochi`
};

const ja_chat_title = /** @type {(inputs: {}) => string} */ () => {
	return `モチとチャット`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "id" | "ja" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const chat_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.chat_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("chat_title", locale)
	if (locale === "en") return en_chat_title(inputs)
	if (locale === "id") return id_chat_title(inputs)
	return ja_chat_title(inputs)
};
export { chat_title as "chat.title" }